import {AxiosError, AxiosResponse} from 'axios';
import {LS_TOKEN} from '@/shared/local.storage.utils';
import router from '@/routes';


export default class AccessControlInterceptor {

  // public static Request(config: any) {
  // }
  //
  // public static RequestError(error: AxiosError) {
  // }

  public static Response(response: AxiosResponse) {

    const updatedToken = response.headers['scapin-token'];
    // console.log('Réactualisation du token =', updatedToken);
    localStorage.setItem(LS_TOKEN, updatedToken);
  }

  public static ResponseError(error: AxiosError) {
    const rname = router.currentRoute.name;
    const requrl = error.config && error.config.url ? error.config.url : '';
    const code = error.response ? error.response.status : 0;
    console.log(`ResponseError code=${code}, requrl=${requrl}, rname=${rname}`);

    // Seules les erreurs 401 et 403 sont traitées en dehors du contexte de login
    if (!requrl.endsWith('master/login') && (code === 401 || code === 403)) {
      // Si la page courante n'est pas la mire de login
      if (rname !== 'adminlogin') {
        const params = code === 403 ? {code: `${code}`, msg: error.response ? error.response.data as string : ''} : undefined;
        router.push({name: 'adminlogin', params}).then();
      }
    }

    // Autre erreur => on ne fait rien
  }
}
